import gql from 'graphql-tag';

import byNameCountFragment from '../fragments/byNameCountFragment';
import integrationItemFragment from '../fragments/integrationItemFragment';

export const queryCounts = gql`
  query onboardingBlockingContent {
    onboardingBlockingContent {
      dokkioClass
      organizationNameCounts {
        ...byNameCountFragment
      }
      locationNameCounts {
        ...byNameCountFragment
      }
      personNameCounts {
        ...byNameCountFragment
      }
      topicCounts {
        ...byNameCountFragment
      }
      categoryCounts {
        ...byNameCountFragment
      }
      summaryIntegrationItems {
        ...integrationItemFragment
      }
      captionIntegrationItems {
        ...integrationItemFragment
      }
    }
  }
  ${byNameCountFragment}
  ${integrationItemFragment}
`;
export default queryCounts;
